<template>
  <div>
    <div class="loginbox">
      <span class="notice-text">{{ this.checkNotice }}</span>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import * as dd from 'dingtalk-jsapi';
import lockr from 'lockr';

export default {
  name: 'DingSign',
  data() {
    return {
      checkNotice: '',
    };
  },
  methods: {
    checkSign() {
      let that = this;
      dd.runtime.permission.requestAuthCode({
        corpId: 'ding401dd62104016fd535c2f4657eb6378f',
        onSuccess: function(result) {
          _post({
            url: '/index/login/dingLoginByCode',
            data: {
              code: result.code,
              site: that.$siteName,
              teacherId: that.$route.params.teacherId,
              crmId: that.$route.params.crmId,
            }
          }).then((res) => {
            if (res.result === 1) {
              lockr.set('jwt', res.data.token);
              switch (that.$siteName) {
                case 'training':
                  window.location.href = `/customer/edit/${that.$route.params.crmId}`;
                  break;
                case 'job':
                  window.location.href = `/member/edit/${that.$route.params.crmId}`;
                  break;
                default:
                  window.location.href = `/frontend/h5/user/${that.$route.params.crmId}`;
                  break;
              }
            } else {
              that.errorMsg = res.msg;
              that.$message.error(res.msg);
            }
          });
        }
      });
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
  },
  mounted() {
    this.$nextTick(() => {
      this.checkSign();
    });
  }
};
</script>

<style>
body {
  height: 100%;
  background-image: url('../assets/login/images/bg.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
}
#app {
  padding-top: 130px;
}
h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
input {
  border: none;
  background: none;
  width: 300px;
  height: 55px;
  border: none;
  line-height: 74px;
  font-size: 18px;
  outline: none;
  border-bottom: 1px solid #838BA9;
  color: #fff;
  font-family: "微软雅黑", Microsoft Yahei;
}
li.input-icon {
  background: url('../assets/starmap/images/icon-name.png') no-repeat left center;
}
li.icon-pwd {
  background-image: url('../assets/starmap/images/icon-pass.png')
}
.login-btn {
  background-color: #FFF;
  cursor: pointer;
  color: #00285d;
  height: 50px;
  width: 384px;
  border: none;
  border-radius: 50px;
  margin-top: 40px;
}
.logintitle {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite;
}
.logintitle2 {
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 200;
  padding: 70px 0;
}
.loginbox {
  width: auto;
  height: 336px;
  margin: auto;
  text-align: center;
  padding-bottom: 40px;
  animation: loginmove 1s ease-out 1;
}

.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 5px 0;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  bottom: 0;
  display: block;
  width: 211px;
  text-align: center;
  line-height: 30px;
  background-color: #fcd71d;
  font-size: 18px;
  color: #383838;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  bottom: 10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
}

.loginbm {
  line-height: 23px;
  text-align: center;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}

.loginbm a {
  font-weight: bold;
  color: #fff;
}

.loginbm a:hover {
  color: #fff;
}

.notice-text {
  font-weight: bold;
  font-size: 48px;
  color: #fff;

}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
